//! navbar

"use client";

import Link from "next/link";
import { useState } from "react";
import DropdownItem from "./DropdownItem";
import { PRINCING } from "routes";

const desktopNavLinkClass = "btn-ghost inline-flex items-center";
const mobileNavLinkClass = "btn-ghost inline-flex items-center text-[#292929]";

export default function Navbar({ isOpen, toggleMenu, isMobile = false }) {
  const handleClick = isOpen ? toggleMenu : undefined;
  const navLinkClass = isMobile ? mobileNavLinkClass : desktopNavLinkClass;
  const [activeMenu, setActiveMenu] = useState(null);

  return (
    <nav
      className={
        isMobile
          ? "flex flex-col space-y-4 p-2"
          : "flex flex-col items-stretch md:flex-row md:items-center"
      }
    >
      <div
        className={
          isMobile
            ? "flex flex-col space-y-4"
            : "flex flex-col gap-1 md:flex-1 md:flex-row md:items-center md:justify-center xl:gap-2"
        }
      >
        <DropdownItem
          title="Solutions"
          isMobile={isMobile}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          closeMenu={handleClick}
        />

        <Link href={PRINCING} onClick={handleClick} className={navLinkClass}>
          Pricing
        </Link>
        <Link href="/blog" onClick={handleClick} className={navLinkClass}>
          Blog
        </Link>
      </div>
    </nav>
  );
}
